<script lang="ts">
	import { disabledButtonClasses, setLoadingState } from '$lib/actions/setLoadingState';
	import { sleep } from '$lib/common';
	import type { Snippet } from 'svelte';
	import type { HTMLButtonAttributes } from 'svelte/elements';

	type Props = {
		onClick?: () => Promise<void> | void;
		loading?: boolean;
		type?: 'button' | 'submit';
		disabled?: boolean;
		class?: string;
		children?: Snippet;
	} & HTMLButtonAttributes;

	let {
		onClick = async () => {},
		loading = undefined,
		type = 'button' as 'button' | 'submit',
		disabled = false,
		class: klass,
		onclick,
		children,
		...rest
	}: Props = $props();

	let classes = $derived((disabled ? disabledButtonClasses.join(' ') + ' !cursor-not-allowed' : '') + ' ' + klass);

	let loadingStart: Date;

	let handleLoadingOnClick = loading === undefined;

	async function click(event: any) {
		if (disabled) return;
		if (handleLoadingOnClick) {
			loading = true;
			loadingStart = new Date();
		}
		try {
			await onClick();
			onclick?.(event);

			if (handleLoadingOnClick) {
				// ensure the button is loading for at least 500ms
				const loadingDuration = new Date().getTime() - loadingStart.getTime();
				if (loadingDuration < 500) {
					await sleep(500 - loadingDuration);
				}
			}
		} finally {
			if (handleLoadingOnClick) {
				loading = false;
			}
		}
	}
</script>

<button {...rest} class={classes} {disabled} {type} onclick={click} use:setLoadingState={loading ?? false}>
	{@render children?.()}
</button>
